import {z} from "zod/v4-mini"

export const vectorMathNodeOperation = z.enum([
    "ADD",
    "SUBTRACT",
    "MULTIPLY",
    "DIVIDE",
    "CROSS_PRODUCT",
    "PROJECT",
    "REFLECT",
    "REFRACT",
    "FACEFORWARD",
    "MULTIPLY_ADD",
    "DOT_PRODUCT",
    "DISTANCE",
    "LENGTH",
    "SCALE",
    "NORMALIZE",
    "SNAP",
    "FLOOR",
    "CEIL",
    "MODULO",
    "WRAP",
    "FRACTION",
    "ABSOLUTE",
    "MINIMUM",
    "MAXIMUM",
    "SINE",
    "COSINE",
    "TANGENT",
])
export type VectorMathNodeOperation = z.infer<typeof vectorMathNodeOperation>
